export function getIXLQuizId(resourceUrl: string): string | null {
  if (resourceUrl) {
    const parts: string[] = resourceUrl.split('/');
    if (parts.length >= 5) {
      return parts[4];
    }
  }
  return null;
}
